// eslint-disable-next-line max-len
const emailExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
const phoneExp = /^(\+7|7|8|)[-\s]?[(]?[0-9]{3}[)]?[-\s]?[0-9]{3}[-\s]?[0-9]{2}[-\s]?[0-9]{2}$/
const numExp = /^\d+$/

/**
 * Simple validation helper.
 * If not enough this class functions, try library https://github.com/imbrn/v8n
 * Be free to add new checkers.
 */
export default class<T = unknown> {
  errors: string[] = []
  value?: T
  skipOnError = false

  constructor(value: T) {
    this.value = value
  }

  required(errorMessage: string, skipNextOnError = true): this {
    if (!this.value) {
      // При this.skipOnError равном true, и наличии ошибок валидации, следующие методы валидации не будут выполняться.
      this.skipOnError = skipNextOnError
      this.errors.push(errorMessage)
    }
    return this
  }

  isEmail(errorMessage: string): this {
    if (this.skip()) {
      return this
    }
    if (!this.value || !emailExp.test((<string>this.value).toLowerCase())) {
      this.errors.push(errorMessage)
    }
    return this
  }

  isPhone(errorMessage: string): this {
    if (this.skip()) {
      return this
    }
    if (
      !this.value ||
      !phoneExp.test((<string>this.value).toLowerCase())
    ) {
      this.errors.push(errorMessage)
    }
    return this
  }

  isNumeric(errorMessage: string): this {
    if (this.skip()) {
      return this
    }
    if (!numExp.test(<string>this.value)) {
      this.errors.push(errorMessage)
    }
    return this
  }

  lengths(lengths: number[], errorMessage: string): this {
    if (this.skip()) {
      return this
    }
    if ((Array.isArray(this.value) || typeof this.value === 'string') && !lengths.includes(this.value?.length)) {
      this.errors.push(errorMessage)
    }
    return this
  }

  skip(): boolean {
    return this.skipOnError && this.hasError()
  }

  hasError(): boolean {
    return this.errors.length !== 0
  }

  firstError(): string {
    if (this.hasError()) {
      return this.errors[0]
    }
    return ''
  }

  allErrors(): string[] {
    return this.errors
  }

  allErrorsToString(): string {
    return this.errors.join('\n')
  }

  min(limit: number, errorMessage: string): this {
    if (this.skip()) {
      return this
    }
    if (typeof this.value === 'string' && this.value.length < limit) {
      this.errors.push(errorMessage)
    }
    return this
  }

  identical(value: unknown, errorMessage: string): this {
    if (this.skip()) {
      return this
    }
    if (this.value !== value) {
      this.errors.push(errorMessage)
    }
    return this
  }

}
